"use client";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import axios from "axios";

const RecaptchaValidation = () => {
  const { executeRecaptcha } = useGoogleReCaptcha();

  const handleRecaptcha = async () => {
    if (!executeRecaptcha) {
      return true;
    }
    try {
      const gRecaptchaToken = await executeRecaptcha("validateForm");
      const response = await axios({
        method: "POST",
        url: "/website-recaptcha/recaptcha",
        data: {
          gRecaptchaToken,
        },
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
        },
      });

      if (response?.data?.success === true) {
        return true;
      } else {
        return false;
      }
    } catch (e) {
      console.log(e);
      return true;
    }
  };

  return { handleRecaptcha };
};

export default RecaptchaValidation;
